@let localForm = formChange();

<mat-dialog-content id='change-password-modal' class='modal-dialog'>
  <div class='modal-content'>
    <div class='modal-header p-0 mb-3'>
      <h2 class='modal-title unbold'>
        {{ 'cambiar_contrasenia' | translate }}
      </h2>
      <span class='dismiss-modal' (click)='dialogRef.close()'>X</span>
    </div>
    <hr />
    <div class='modal-body p-0'>
      <form [formGroup]='localForm'>
        <div class='row'>
          <div class='col-md-12 mt-1'>
            <div class='form-group'>
              <label class='control-label'>{{ 'password' | translate }}</label>
              <div class='position-relative'>
                <input
                  [type]="showNowPassword() ? 'text' : 'password'"
                  class='form-control pe-5'
                  formControlName='now_password'
                  appFormValidation
                />
                <button
                  type='button'
                  class='eye-btn'
                  (click)='toggleNowPassword()'
                  title='Mostrar/Ocultar'
                >
                  @if (showNowPassword()) {
                  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16'
                   fill='currentColor' class='bi bi-eye-slash' viewBox='0 0 16 16'>
                    <path d='M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z'/>
                    <path d='M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829'/>
                    <path d='M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z'/>
                  </svg>
                  } @else {
                  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16'
                      fill='currentColor' class='bi bi-eye' viewBox='0 0 16 16'>
                   <path d='M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z'/>
                   <path d='M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0'/>
                 </svg>
                  }
                </button>
              </div>
              <app-form-error [control]="localForm.get('now_password')" class='d-block mt-1'></app-form-error>
              @if (serverErrors().now_password?.length) {
                @for (err of serverErrors().now_password; track $index) {
                <p class="error mb-0">{{ err }}</p>
                }
              }
            </div>
          </div>
          <div class='col-md-12 mt-1'>
            <div class='form-group'>
              <label class='control-label'>{{ 'new_password' | translate }}</label>
              <div class='position-relative'>
                <input
                  [type]="showNewPassword() ? 'text' : 'password'"
                  class='form-control'
                  formControlName='password'
                  appFormValidation
                />
                <button
                  type='button'
                  class='eye-btn'
                  (click)='toggleNewPassword()'
                  title='Mostrar/Ocultar'
                >
                  @if (showNewPassword()) {
                  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16'
                     fill='currentColor' class='bi bi-eye-slash' viewBox='0 0 16 16'>
                    <path d='M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z'/>
                    <path d='M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829'/>
                    <path d='M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z'/>
                  </svg>
                  } @else {
                  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16'
                       fill='currentColor' class='bi bi-eye' viewBox='0 0 16 16'>
                    <path d='M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z'/>
                    <path d='M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0'/>
                  </svg>
                  }
                </button>
              </div>
              <app-form-error [control]="localForm.get('password')" class='d-block mt-1'></app-form-error>

            </div>
          </div>
          <div class='col-md-12'>
            <div class='form-group'>
              <label class='control-label'>{{
                'components.register_form.confirm_password' | translate
                }}</label>
              <div class='position-relative'>
                <input
                  [type]="showRePassword() ? 'text' : 'password'"
                  class='form-control'
                  formControlName='re_password'
                  appFormValidation
                />
                <button
                  type="button"
                  class="eye-btn"
                  (click)="toggleRePassword()"
                  title="Mostrar/Ocultar"
                >
                  @if (showRePassword()) {
                  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16'
                     fill='currentColor' class='bi bi-eye-slash' viewBox='0 0 16 16'>
                    <path d='M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z'/>
                    <path d='M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829'/>
                    <path d='M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z'/>
                  </svg>
                  } @else {
                  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16'
                       fill='currentColor' class='bi bi-eye' viewBox='0 0 16 16'>
                    <path d='M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z'/>
                    <path d='M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0'/>
                  </svg>
                  }
                </button>
              </div>
              <app-form-error [control]="localForm.get('re_password')" class='d-block mt-1'></app-form-error>
              @if (
              localForm.get('re_password')?.errors &&
              localForm.get('re_password')?.errors?.confirmPassword
              ) {
              <div class="error invalid-feedback">
              {{ 'components.register_form.password_not_match' | translate }}
              </div>
              }
            </div>
          </div>
          <button type='button' class='dark-blue fw-normal w-auto mx-auto' (click)='close()'>
            {{ 'confirmar' | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</mat-dialog-content>
